// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1e6F6","dragIcon":"Choice_dragIcon__1Hk7b","left":"Choice_left__21faK","input":"Choice_input__2JwE2"};